import React from 'react';
import { Zap } from 'lucide-react';

export const ActiveWorkoutState: React.FC = () => (
    <div style={{ padding: '40px 20px', textAlign: 'center', backgroundColor: 'rgba(59, 130, 246, 0.05)', borderRadius: '16px', border: '1px solid rgba(59, 130, 246, 0.1)' }}>
        <Zap size={40} color="#3b82f6" className="animate-pulse" style={{ margin: '0 auto 20px' }} />
        <h3 style={{ fontSize: '14px', fontWeight: '900', color: '#fff', marginBottom: '10px' }}>SESSION IS LIVE</h3>
        <p style={{ fontSize: '12px', color: '#666', lineHeight: '1.5' }}>
            This event is currently being tracked in the high-fidelity session tracker. Please use the tracker to log your sets in real-time.
        </p>
    </div>
);
